import { render } from "./NewCollection.vue?vue&type=template&id=be558650"
import script from "./NewCollection.vue?vue&type=script&lang=js"
export * from "./NewCollection.vue?vue&type=script&lang=js"
script.render = render

export default script